export default function ErrorBox({text}) {
  return (
    <div className='box columns is-shadowless'>
      { !!text && 
        <div className='column has-background-danger has-text-light is-three-fifths is-offset-one-fifth'
          dangerouslySetInnerHTML={{__html: text}}/>
      }
    </div>
  )
}